<div class="question-type__text">
  <h1 class="fs__xxl">Carousel Rating</h1>
  <p class="fs__md">
    Use this question type if you want to ask the participant to provide ratings for different subjects. A rating can be either a numeric, star or text based
    rating.
  </p>
  <ul class="question-type__bullet-points">
    <li class="fs__sm">
      <span class="sub-text">Numbers can be from 1 up to any number you want. After 10 the numbers are presented vertically.</span>
    </li>
    <li class="fs__sm">
      <span class="sub-text">Text values will always be presented vertically.</span>
    </li>
    <li class="fs__sm">
      <span class="sub-text"
        >For stars, you can set the range for example, 1-10 and then provided with that number of stars to select from. Up to 8 stars can be presented
        horizontally, after that they are vertical.</span
      >
    </li>
  </ul>
</div>
